export type Principle = { number: string; title: string; line: string };

export const principles: Principle[] = [
  { number: "01", title: "Root cause over repeat fixes", line: "Recurring issues deserve investigation, not normalization." },
  { number: "02", title: "Process over heroics", line: "Critical operations should not depend on one person knowing what to do." },
  { number: "03", title: "Control without complexity", line: "Strong governance should make payroll easier to run, not harder." },
  { number: "04", title: "Continuous improvement", line: "Every payroll cycle should leave the operation stronger than the one before it." },
];
